import { IInitialState } from 'src/store/initialState';

const allOrdersSel = (state: IInitialState): IInitialState['orders'] =>
  state.orders;

export const ordersSel = (state: IInitialState) => allOrdersSel(state).orders;
export const ordersRecentSel = (state: IInitialState) =>
  allOrdersSel(state).recentOrders;
export const ordersPageNumberSel = (state: IInitialState) =>
  allOrdersSel(state).pageNumber;
export const ordersPageSizeSel = (state: IInitialState) =>
  allOrdersSel(state).pageSize;
export const ordersTotalElementsSel = (state: IInitialState) =>
  allOrdersSel(state).totalElements;
export const ordersTotalPagesSel = (state: IInitialState) =>
  allOrdersSel(state).totalPages;
export const ordersIsPendingSel = (state: any) => allOrdersSel(state).isPending;
export const ordersErrorSel = (state: any) => allOrdersSel(state).error;
export const ordersTrackingNumberSel = (state: any) =>
  allOrdersSel(state).trackingNumbers;
